import React from "react";
import PropTypes from "prop-types";
import { PrimaryButton, ButtonLink } from "../../../../components/Buttons";

import {
  W3Dropdown,
  W3DropdownToggler,
  W3DropdownContent,
} from "../../../../components/W3Dropdown";
import ITTaskDialog from "./ITTaskDialog";
import ActionFilter from "../ActionFilter";

export default function JarvisConnectionTaskMenu({
  className = "",
  items = [],
  filterConnections,
  connectionTaskType,
  selectedJarvisConnections,
  exportJarvisConnections,
  closeJarvisConnections,
}) {
  const taskDialogRef = React.useRef(null);

  const onExport = React.useCallback(
    (event) => {
      if (event) event.preventDefault();
      const type = "Jarvis";
      let counter = 0;
      if (selectedJarvisConnections && selectedJarvisConnections.length > 0) {
        counter += selectedJarvisConnections.length;
      }
      const isSingular = counter === 1;
      taskDialogRef.current.show(
        true,
        {
          title: `JARVIS-Zugänge exportieren`,
          text: `
          ${isSingular ? "Der" : "Alle " + counter} ausgewählte JARVIS- ${isSingular ? "Zugang wird" : "Zugänge werden"} für die  
          Weiterverarbeitung vorbereitet und als CSV exportiert. Wollen Sie fortfahren?
        `,
          type: type.toUpperCase(),
          showValidity: false,
          taskType: connectionTaskType,
          showTaskType: false,
        },
        (data) => exportJarvisConnections(data),
      );
    },
    [selectedJarvisConnections, exportJarvisConnections],
  );

  const onClose = React.useCallback(
    (event) => {
      if (event) event.preventDefault();
      let counter = 0;
      let isSingle = true;
      if (selectedJarvisConnections && selectedJarvisConnections.length > 0) {
        counter += selectedJarvisConnections.length;
        isSingle = selectedJarvisConnections.length === 1;
      }
      taskDialogRef.current.show(
        true,
        {
          title: `JARVIS-Zugangsaufgabe${isSingle ? "" : "n"} schließen`,
          text: `
          ${isSingle ? "Der" : "Alle " + counter} ausgewählte JARVIS- ${isSingle ? "Zugang wird" : "Zugänge werden"} nun abgeschlossen.  
          Wollen Sie fortfahren?
        `,
          showTaskType: false,
        },
        () => closeJarvisConnections(selectedJarvisConnections),
      );
    },
    [selectedJarvisConnections, closeJarvisConnections],
  );

  const isJarvisExportable =
    selectedJarvisConnections && selectedJarvisConnections.length > 0;

  return (
    <div className={className}>
      <div className="w3-cell-row">
        <div className="w3-cell w3-cell-middle pad-rht">
          <ActionFilter
            type="Jarvis"
            taskType={connectionTaskType}
            setTaskType={filterConnections}
            itemsToCount={items}
            className="display-inline-block"
          />
        </div>
        <div className="w3-cell w3-cell-middle pad-lft">
          <W3Dropdown className="modems dropdown-list-menu">
            <W3DropdownToggler
              as={PrimaryButton}
              size=""
            >{`Optionen`}</W3DropdownToggler>
            <W3DropdownContent
              className="w3-bar-block w3-border"
              style={{ right: "0", width: "320px" }}
            >
              <ButtonLink
                to="#"
                className="w3-bar-item dropdown-list-menu-item bg-secondary-hover"
                onClick={onExport}
                disabled={!isJarvisExportable}
              >
                {`JARVIS-Zugänge exportieren (CSV)`}
              </ButtonLink>
              <a href="#" className="w3-bar-item separator">
                <div className="w3-border-top" style={{ margin: "0 -4px" }} />
              </a>
              <ButtonLink
                to="#"
                className="w3-bar-item dropdown-list-menu-item bg-secondary-hover"
                onClick={onClose}
                disabled={!isJarvisExportable}
              >
                {`JARVIS-Zugänge schließen`}
              </ButtonLink>
            </W3DropdownContent>
          </W3Dropdown>
        </div>
      </div>
      <ITTaskDialog ref={taskDialogRef} />
    </div>
  );
}

JarvisConnectionTaskMenu.propTypes = {
  className: PropTypes.string,
  selectedJarvisConnections: PropTypes.array,
  connectionTaskType: PropTypes.string,
  exportJarvisConnections: PropTypes.func.isRequired,
  filterConnections: PropTypes.func.isRequired,
  items: PropTypes.array,
  history: PropTypes.object,
};
